import React, { Component } from 'react';
import axios from 'axios';
import PanelQuestions from './components/PanelQuestions';
import PanelAnswers from './components/PanelAnswers';
import PanelFinished from './components/PanelFinished';
import PanelStart from './components/PanelStart';
import logo from './toneheim-logo-white.svg';
import './styles/Quiz.css';

const DATA_ENDPOINT = document.getElementById('root').getAttribute('data-endpoint') || "/QuizData.json";
const DATA_JSON = document.getElementById('root').getAttribute('data-json');

class Quiz extends Component {
  constructor(props) {
    super(props);

    this.defaults = {
      showLogo: false,
      finished: false,
      questionNo: 0,
      points: 0,
      status: 'Laster quiz...',
    }

    this.state = {...this.defaults, started: false};
  }

  componentDidMount() {
    this.getData();
  }

  /**
   * Make sure points are ints
   */
  cleanData(data) {
    data.questions.forEach(question => {
      question.answers.forEach(answer => {
        answer.points = parseInt(answer.points, 10);
      })
    })
  }

  /**
   * Gets the JSON data for the Quiz and sums the highest possible score
   */
  getData = () => {
    if(DATA_JSON) {
      let jsondata = JSON.parse(DATA_JSON);
      this.cleanData(jsondata);

      this.setState({
        data: jsondata,
        totalPoints: this.getHighestScore(jsondata),
      })
    } else {
      axios.get(DATA_ENDPOINT)
      .then((response) => {
        this.setState({ 
          data: response.data,
          totalPoints: this.getHighestScore(response.data),
        })
      })
      .catch((error) => {
        this.setState({
          status: 'Kunne ikke laste quiz...'
        })
        console.log(error);
      });
    }
  }

  /**
   * Resets the Quiz state to defaults
   * @param {boolean} hasStarted If true will reset to question 0, if false will reset to the intro before the Quiz starts
   */
  reset(hasStarted = true) {
    this.setState({...this.defaults, started: hasStarted});
  }

  /**
   * Get the highest possible score for the quiz
   * Loops all questions and gets the highest amount of points for each answer, then sums them
   */
  getHighestScore = (data) => {
    return data.questions.map(question => {
        return Math.max.apply(Math, question.answers.map(o => o.points))
    }).reduce((a, b) => a + b, 0);
  }

  /**
   * Gets the current answer
   */
  getAnswers = () => {
    if(this.state.questionNo === this.state.data.questions.length) return;
    return this.state.data.questions[this.state.questionNo].answers;
  }

  /**
   * Gets the current question
   */
  getQuestion = () => {
    if(this.state.questionNo === this.state.data.questions.length) return;
    return this.state.data.questions[this.state.questionNo].question;
  }

  /**
   * Click event when pressing an answer
   * Adds points, increments which question you're on, checks if you're finished
   * Also, has a timeout on the answered state to toggle animations
   * @param {*} i 
   */
  handleAnswerClick(i) {
    let answer = this.state.data.questions[this.state.questionNo].answers[i];
    let finished = false;
    let question = this.state.questionNo + 1; 

    if (question === this.state.data.questions.length) {
      question = this.state.questionNo;
      finished = true;
    } 

    this.setState({
      finished: finished,
      answered: true,
      questionNo: question,
      points: this.state.points + answer.points
    })

    setTimeout(() => {
      this.setState({
        answered: false,
      })
    },300)
  }

  /**
   * Click event to reset the quiz
   * Resets it back to the first answer, not to the very first intro step
   */
  handleResetClick() {
    this.reset();
  }

  /**
   * Click event to Start the Quiz
   */
  handleStartClick() {
    this.setState({
      started: true,
    })
  }

  /**
   * Get the final result object based on the score out of the total score, 
   * separated into set tiers low|medium|high
   * Low = less than 16%
   * Medium = 16% to less than 60%
   * High = 60% or over
   */
  getFinish() {
    let response;

    switch (true) {
      case (this.state.points < (this.state.totalPoints / 6)):
        response = this.state.data.response.low;
          break;
      case (this.state.points >= (this.state.totalPoints / 6) && this.state.points < (this.state.totalPoints / 1.66)):
        response = this.state.data.response.medium;
          break;
      case (this.state.points >= (this.state.totalPoints / 1.66)):
        response = this.state.data.response.high;
          break;
      default:
        response = false;
          break;
    }

    return response;
  }

  /**
   * Handles which panels are active based on the quiz progress
   */
  handlePanels() {
    if(!this.state.started) {
      return (
        <div className="quiz__inner">
          <PanelStart 
          intro={this.state.data.intro}
          onClick={(i) => this.handleStartClick()} />
        </div>
      );
    } else if(this.state.started && !this.state.finished) {
      return (
        <div className="quiz__inner">
          <PanelQuestions 
          answered={this.state.answered}
          question={this.getQuestion()} />

          <PanelAnswers 
          answered={this.state.answered}
          answers={this.getAnswers()} 
          onClick={(i) => this.handleAnswerClick(i)} />
        </div>
      );
    } else {
      return (
        <div className="quiz__inner">
          <PanelFinished 
          points={this.state.points} 
          totalPoints={this.state.totalPoints} 
          finish={this.getFinish()} 
          facebook={this.state.data.facebook}
          ending={this.state.data.ending}
          onClick={() => this.handleResetClick()} />
        </div>
      );
    }
  }

  /**
   * Handles the visibility of the logo
   */
  handleLogo() {
    if(this.state.showLogo) { 
      return (
        <a href={this.state.data.logo.target} className="quiz__logo">
          <img src={logo} alt={this.state.data.logo.title} />
        </a>
      )
    }
  }

  render() {
    if (!this.state.data) {
      return(
        <div className="quiz is-loading">
          <div className="quiz__loading" aria-live="assertive" role="alert">
            <span className="quiz__spinner"></span>
            <p className="quiz__status">{this.state.status}</p>
          </div>
        </div>
      ); 
    }

    return (
      <div className="quiz">
          {this.handleLogo()}
          {this.handlePanels()}
      </div>
    );
  }
}

export default Quiz;



// WEBPACK FOOTER //
// ./src/Quiz.js